import { ensureViewExists } from './ensure-view-exists';
import type { ImmerSet, ViewDimensionActions } from '../../types/filter-actions-types';

export function createViewDimensionActions(set: ImmerSet): ViewDimensionActions {
  return {
    setViewDimension: (viewId, dimension) => {
      set(state => {
        const view = ensureViewExists(state, viewId);
        view.viewDimension = dimension;
      });
    },

    clearViewDimension: (viewId) => {
      set(state => {
        const view = ensureViewExists(state, viewId);
        view.viewDimension = undefined;
      });
    },
  };
}
